import MUILoadingButton from '@mui/lab/LoadingButton';
import cx from 'classnames';
import { forwardRef, ForwardRefRenderFunction } from 'react';

import styles from './Button.module.scss';

export type ButtonProps = Omit<
  React.ComponentPropsWithRef<'button'>,
  'color'
> & {
  variant?: 'text' | 'contained' | 'outlined';
  color?: 'primary' | 'secondary' | 'tertiary' | 'danger';
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  fullWidth?: boolean;
  renderSpan?: boolean;
  href?: string;
  size?: 'L' | 'M' | 'S';
  component?: React.ReactNode;
  loading?: boolean;
  loadingPosition?: 'start' | 'end';
};

const Button: ForwardRefRenderFunction<HTMLButtonElement, ButtonProps> = (
  {
    variant = 'contained',
    color = 'primary',
    startIcon,
    endIcon,
    className,
    renderSpan = false,
    size = 'M',
    loading = false,
    loadingPosition = 'start',
    ...rest
  },
  ref,
) => (
  <MUILoadingButton
    ref={ref}
    component={renderSpan ? 'span' : 'button'}
    variant={variant}
    startIcon={loadingPosition === 'start' ? startIcon : undefined}
    loadingPosition={startIcon ? loadingPosition : undefined}
    loading={loading}
    endIcon={loadingPosition === 'end' ? endIcon : undefined}
    classes={{ root: styles.container }}
    className={cx(
      {
        [styles.primary]: color === 'primary',
        [styles.secondary]: color === 'secondary',
        [styles.tertiary]: color === 'tertiary',
        [styles.danger]: color === 'danger',
        [styles.large]: size === 'L',
        [styles.medium]: size === 'M',
        [styles.small]: size === 'S',
      },
      className,
    )}
    {...rest}
  />
);

export default forwardRef(Button);
